const brandFont = "fleuronregular, sans-serif";

export default brandFont;